import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServerRootService } from '../utils/routing/serverroot.service';
import { VisitService } from './rest/visit.service';
import { EcgService } from './rest/ecg.service';

@Injectable({
    providedIn: 'root',
})
export class WadoService extends ServerRootService {
    private readonly apiController: string;

    constructor(
        private httpClient: HttpClient,
        private visitRestService: VisitService,
        private ecgRestService: EcgService,
    ) {
        super();

        this.apiController = `${this.getServerRoot()}/Wado`;
    }

    get(objectUID: string, contentType: string = 'application/pdf'): Observable<ArrayBuffer> {
        const params = {
            contentType,
            objectUID,
        };

        return this.httpClient.post(`${this.apiController}/WadoProxyGeneric`, params, {
            responseType: 'arraybuffer',
        });
    }

    getBase64(objectUID: string, contentType: string = 'application/pdf') {
        const params = {
            contentType,
            objectUID,
        };

        return this.httpClient.post<string>(`${this.apiController}/WadoProxyGeneric`, params, this.buildOptions());
    }

    getWadoPdf(objectUID: string, contentType: string = 'application/pdf') {
        const params = {
            contentType,
            objectUID,
        };

        return this.httpClient.post<string>(
            `${this.apiController}/WadoProxyGenericByteArray`,
            params,
            this.buildOptions(),
        );
    }

    // TODO: 34.13: TROVARE FIX DEFINITIVO
    getEcgPdf(reportIds: string[], displayedSettings: any, ignoreErrors: boolean = false) {
        return this.ecgRestService.getEcgPdf(reportIds, displayedSettings, ignoreErrors);
    }

    getVisitPdf(reportIds: string[], displayedSettings: any, smCertificateCode?: string) {
        return this.visitRestService.getVisitPdf(reportIds, displayedSettings, smCertificateCode);
    }

    getPreviewEcgPdf(examinationId: string) {
        return this.ecgRestService.getPreviewEcgPdf(examinationId);
    }
}
